import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Bootstrap Icons（管理画面で使用）
import 'bootstrap-icons/font/bootstrap-icons.css'

// Google Material Symbols Rounded（管理画面で使用）
const materialIconsLink = document.createElement('link')
materialIconsLink.rel = 'stylesheet'
materialIconsLink.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@24,400,0,0'
document.head.appendChild(materialIconsLink)

// Google Fonts - Inter（Material Dashboard用）
const interLink = document.createElement('link')
interLink.rel = 'stylesheet'
interLink.href = 'https://fonts.googleapis.com/css?family=Inter:300,400,500,600,700,900'
document.head.appendChild(interLink)

createApp(App).use(router).mount('#app')
